import { useEffect, useState } from 'react';

import cn from 'classnames';
import { Link } from 'react-router-dom';
import WarehouseCommonApi from '../../../../API/warehouse/common-api';
import delete_img from '../../../../assets/media/bucket.svg';
import pencil from '../../../../assets/media/icons/icon_pencil.svg';
import default_product from '../../../../assets/media/icons/products.png';
import { Column, ImagesViewer, Row } from '../../../../components/Basic/Blocks';
import { AnimateArrow, ButtonWithTooltip } from '../../../../components/Basic/Buttons';
import { Icon } from '../../../../components/Basic/Elements';
import { Select } from '../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { TextGrey } from '../../../../components/Basic/WrapsStyle';
import MarketsPairs from '../../../../components/Common/Elements/MarketsPairs';
import BarcodesBlock from '../../../../components/Common/Input/Barcodes';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import WarehouseAddressInput from '../../../../components/Warehouse/WarehouseAddressInput';
import { IP, TO_PRODUCT } from '../../../../constans';
import WarehouseHistoryBlock from '../ProductHistory/Content';
import styles from '../styles.module.scss';
import ReserveStepperInput from './ReserveStepperInput';
import WarehouseStepperInput from './WarehouseStepperInput';

const ProductsTableLine = ({
  item = {},
  width = [],
  isOwner,
  onSave = () => { },
  setRemove = () => { },
  isInventory = false,
  tab,
  skladName,
  inventoried = false,
  ...props
}) => {

  const [product, setProduct] = useState(item);

  const [isOpenHistory, setIsOpenHistory] = useState(false);

  const onChange = async (field, value, action = null) => {
    await WarehouseCommonApi.changeProduct({ data: { warehouseId: product.id, field, value, action, isInventory: false, skladName } }).then((p) =>
      setProduct(p.warehouseProduct),
    );
  };

  useEffect(() => {
    setIsOpenHistory(false);
    setProduct(item);
  }, [item.id]);

  return (
    <>
      <TableLine white={true} key={product._id} style={inventoried && isInventory ? { background: '#39ee3f47' } : {}}>
        <TableCell width={width[0]}>
          <ImagesViewer images={[product.image || default_product]} />
        </TableCell>
        <TableCell width={width[2]}>{product.id}</TableCell>
        <TableCell width={width[9]}>
          <div className={styles.block}>
            <WarehouseAddressInput
              warehouseId={product.id}
              address={product.sklad_data?.[skladName].address}
              width={'100px'}
              onChange={(v) => setProduct(v)}
            />
            <ButtonWithTooltip
              tooltip={isOpenHistory ? 'Скрыть историю изменений' : 'Показать историю изменений'}
              onClick={() => setIsOpenHistory(!isOpenHistory)}
            >
              <AnimateArrow
                isOpen={isOpenHistory}
                /*  isOpen={disabled ? (_) => _ : isOpen}*/
                styles={cn(styles.open_icon_arrow)}
              />
            </ButtonWithTooltip>
          </div>
        </TableCell>
        <TableCell width={width[1]} fontSize="14px">
          <Column>
            <Link to={TO_PRODUCT(product.id)} className={styles.link}>
              {product.name}
            </Link>
            <TextGrey style={{ width: '100%', fontSize: '12px' }}>{product.category}</TextGrey>
          </Column>
        </TableCell>

        {(isInventory && tab === 4) || (!isInventory && tab === 5) && (
          <TableCell width={width[3]} fontSize="14px">
            <Select
              select={product.ip}
              onSelect={(ip) => onChange('ip', ip)}
              list={[IP.ARTEM, IP.NIKOLAY, IP.ALENA, IP.SVETANA, IP.IRA, IP.TARAS, IP.DIANA, 'Без ИП']}
              width={width}
            />
          </TableCell>
        )}
        {isInventory && (
          <TableCell width={width[3]} fontSize="14px" center>
            <InventoryCell item={product} />
          </TableCell>
        )}

        <TableCell width={width[3]} fontSize="14px" center>
          <WarehouseStepperInput item={product} />
        </TableCell>
        <TableCell width={width[3]} fontSize="14px" center>
          <ReserveStepperInput item={product} />
        </TableCell>
        <TableCell width={width[3]} fontSize="14px">
          <ProviderList selectProviderId={product.provider_id} disabled={true} />
        </TableCell>
        <TableCell width={width[4]} fontSize="14px">
          <BarcodesBlock
            barcodes={product.barcodes}
            onAdd={(b) => onChange('barcode', b, 'add')}
            onRemove={(b) => onChange('barcode', b, 'pull')}
          />
        </TableCell>
        <TableCell width={width[4]} fontSize="14px" style={{ justifyContent: 'flex-end' }}>
          <MarketsPairs market={product.market} width={'25px'} />
        </TableCell>

        <TableCell>
          <Row>
            <ButtonWithTooltip tooltip={'Редактировать'} className={styles.edit_button} to={TO_PRODUCT(product.id)}>
              <Icon src={pencil} className={styles.pencil_img} />
            </ButtonWithTooltip>
            {isOwner && (
              <ButtonWithTooltip tooltip={'Удалить'} onClick={() => setRemove({ open: true, id: product.id })}>
                <Icon src={delete_img} width={'20px'} />
              </ButtonWithTooltip>
            )}
          </Row>
        </TableCell>
      </TableLine>
      {isOpenHistory && (
        <div className={styles.history_block}>
          {product.sklad_data[skladName].history.map((item) => (
            <WarehouseHistoryBlock part={item} key={item['_id']} />
          ))}
        </div>
      )}
    </>
  );
};

export default ProductsTableLine;
